import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import { MoonLoader } from 'react-spinners';

export default function TopRatedMovies() {

    
    
    const [topM, setTopM] = useState(null)
    const [pageNumber, setPageNumber] = useState(1);

   
   

    function nextPage(){
        
        if(pageNumber != 501){
            let x = pageNumber + 1;
            setPageNumber(x)
        }
        else{
            let x = pageNumber;
        }
   }
   function pervPage(){
    
    if(pageNumber != 1){
        let x = pageNumber - 1;
        setPageNumber(x)
       
    }
    else{
        let x = pageNumber;
    }
     
   }

    async function getTopRatedMovies(){
        let {data} = await axios.get(`https://api.themoviedb.org/3/movie/top_rated?api_key=0ada3fcaa2e394ff1ad6ed7e6c5db6c5&language=en-US&page=${pageNumber}`);
        setTopM(data.results)
    }

    useEffect(() => {
    window.scrollTo(0,0);
      
    getTopRatedMovies()
      
    }, [pageNumber])
    


  return <>
  {topM != null ? <>
  <div className='container'>
    <div className='row'>
        <div>
            <h3>Top Rated Movies</h3>
        </div>
        
    {topM.map((movie, idx) => <div key={idx} className='col-md-2 my-2'>
        <Link to={`/moviedetails/${movie.id}`}>
          <div className="movie imghov position-relative">
            <img className='rounded-3 w-100' src={"https://image.tmdb.org/t/p/w500/" + movie.poster_path} alt="moviepic" />
            <h6 className='rating p-2 rounded-circle'>{(movie.vote_average).toFixed(1)}</h6>
            <h6 className='mt-2'>{movie.title}</h6>
          </div>
          </Link>
        </div>)}
    </div>
  </div>
  </>:<><div className='vh-100 d-flex justify-content-center align-items-center'>
    <MoonLoader color="white"/>
    </div></>}
    <div className='my-3 text-center'>
            <h4><span><button onClick={pervPage} className='btn btn-outline-light rounded-5 border-0' ><i className="fa-solid fa-angles-left"></i></button></span> {pageNumber} <span><button onClick={nextPage} className='btn btn-outline-light rounded-5 border-0'><i className="fa-solid fa-angles-right"></i></button></span></h4>
    </div>
    
  </>
}
